import GroupsRounded from '@mui/icons-material/GroupsRounded';
import HowToRegRounded from '@mui/icons-material/HowToRegRounded';
import PersonRounded from '@mui/icons-material/PersonRounded';
import { SectionTabs } from '@/components/SectionTabs';
import { useSession } from '@/platform/session';

export function PeopleTabs() {
  const { role, me } = useSession();
  return (
    <SectionTabs
      label="Seções de pessoas"
      items={[
        { to: '/people', label: 'Pessoas', end: true, icon: <PersonRounded fontSize="small" /> },
        { to: '/people/groups', label: 'Turmas', icon: <GroupsRounded fontSize="small" /> },
        ...(role === 'coordinator'
          ? [
              {
                to: '/admin/approvals',
                label: 'Aprovações',
                badge: me.pendingApprovals,
                icon: <HowToRegRounded fontSize="small" />,
              },
            ]
          : []),
      ]}
    />
  );
}
